/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Button, Modal } from '@mairistem/composants';

interface Props {
  /**
   * Boolean to know if the modal is open
   */
  open: boolean;
  /**
   * Function to close the modal
   */
  onClose: () => void;
  /**
   * Called when the second button of the modal is clicked
   */
  onContinueWithoutSaveModal: () => void;
  /**
   * Called when the third button of the modal is clicked
   */
  onSaveLayersModal: () => void;
}

const ConfirmationModal = (props: Props) => {
  const { onClose, open, onContinueWithoutSaveModal, onSaveLayersModal } =
    props;

  return (
    <Modal closeIcon open={open} onClose={onClose}>
      <Modal.Header content="Attention" />
      <Modal.Content>
        <Modal.Description content="Souhaitez-vous quitter l'acte sans le sauvegarder ?" />
      </Modal.Content>
      <Modal.Actions>
        <Button
          basic
          content="Retour"
          icon="undo"
          size="small"
          onClick={onClose}
        />
        <Button
          negative
          content="Continuer sans sauvegarder"
          icon="close"
          size="small"
          onClick={onContinueWithoutSaveModal}
        />
        <Button
          positive
          content="Sauvegarder & Continuer"
          icon="save"
          size="small"
          onClick={onSaveLayersModal}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ConfirmationModal;
